<template>
  <div class="trip-list">
   <img src="http://res.spreadwin.com/appMenu/OD87BuyVkQAxqwn.png" alt="" srcset="">
  </div>
</template>

<script>
export default {
  name:'airClena',
  data() {
    return {

    }
  },
}
</script>
<style scoped>
  img{
    width: 100%;
  }
</style>
